import React, { useEffect, useRef } from 'react';
import './index.css';
import { IoStarOutline } from "react-icons/io5";
import { IoIosStar } from "react-icons/io";
import { IoMdCheckmark } from "react-icons/io";


export default function Star({ stared = false, total = 0, animate = true }) {

  const contentRef = useRef(null);
  const successRef = useRef(null);

  useEffect(() => {
    if (stared && animate) {
      contentRef.current.classList.add('stared');
      contentRef.current.classList.remove('content');
      successRef.current.classList.add('success-animate');
      setTimeout(() => {
        contentRef.current.classList.add('content-stared');
        contentRef.current.classList.remove('stared');
        successRef.current.classList.remove('success-animate');
      }, 1500);
    } else if (stared) {
      contentRef.current.classList.remove('content');
      contentRef.current.classList.add('content-stared');
    } else {
      contentRef.current.classList.remove('content-stared');
      contentRef.current.classList.add('content');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stared])

  return (
    <div className="star-content">
      <div className="star-number">
        {total}
      </div>
      <div className={`content`} ref={contentRef}>
        Add to favorites
      </div>
      <div className="star-success" ref={successRef}>
        <IoMdCheckmark style={{
          fontSize: '14px',
          marginLeft: '5px'
        }} />
      </div>
      <div className="star">
        {stared ? (
          <IoIosStar style={{
            fontSize: '17px',
            color: '#fed330'
          }} />
        ) : (
          <IoStarOutline style={{
            fontSize: '17px',
            color: '#737373',
          }} />
        )}
      </div>
    </div>
  )
}